import {
  REQUEST_APPOINTMENTS,
  RECEIVE_APPOINTMENTS,
  ADD_APPOINTMENT,
  SET_APPOINTMENT,
  RESET_APPOINTMENT,
  SET_LOADING,
  RESET,
  SET_SIDEP,
  SET_OPTIONAL_FORM_DATA,
  RESET_OPTIONAL_FORM_DATA
} from '../actions/appointments';
import { Appointment } from '../../models';

export type AppointmentsRootState = {
  isLoading: Boolean;
  didInvalidate: Boolean;
  appointments: Array<Appointment>;
  appointment: Partial<Appointment>;
  sidep: {
    symptoms?: string;
    cpam?: string;
    professionnel?: string;
    residence?: string;
    'residence-principale'?: string;
    paysActuel?: any;
    'departement-actuel'?: any;
    'retour-voyage'?: string;
    pays?: any;
    voyage?: {
      type: "Carte nationale d'identité" | 'Passeport';
      numero: number;
    };
    consent?: string;
  };
  optionalForms: {
    [key: string]: {
      key: string;
      label: string;
      value: any;
    }[];
  };
};

const baseState = {
  isLoading: false,
  didInvalidate: false,
  appointments: [],
  appointment: {},
  sidep: {},
  optionalForms: {}
};

function appointments(state: AppointmentsRootState = baseState, action: any) {
  switch (action.type) {
    case ADD_APPOINTMENT:
      return Object.assign({}, state, {
        appointments: [
          ...state.appointments,
          {
            id: action.id,
            completed: false
          }
        ]
      });
    case SET_APPOINTMENT:
      return Object.assign({}, state, {
        appointment: {
          ...state.appointment,
          ...action.appointment
        }
      });
    case RESET_APPOINTMENT:
      return Object.assign({}, state, {
        appointment: {},
        sidep: {}
      });
    case REQUEST_APPOINTMENTS:
      return Object.assign({}, state, {
        isLoading: true,
        didInvalidate: false
      });
    case RECEIVE_APPOINTMENTS:
      return Object.assign({}, state, {
        isLoading: false,
        didInvalidate: false,
        appointments: action.appointments,
        lastUpdated: action.receivedAt
      });
    case SET_LOADING:
      return Object.assign({}, state, {
        isLoading: action.toggle || false
      });
    case SET_SIDEP:
      return Object.assign({}, state, {
        sidep: {
          ...state.sidep,
          [action.key]: action.value
        }
      });
    case SET_OPTIONAL_FORM_DATA:
      return Object.assign({}, state, {
        optionalForms: {
          ...state.optionalForms,
          [action.key]: action.data
        }
      });
    case RESET_OPTIONAL_FORM_DATA:
      return Object.assign({}, state, {
        optionalForms: {}
      });
    case RESET:
      return Object.assign({}, baseState);
    default:
      return state;
  }
}

export default appointments;
